(function () {
  const tabs = document.querySelectorAll('.js_tab');
  const tabContents = document.querySelectorAll('.tab_content .tab_element');
  
  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const tabId = tab.getAttribute('data-bid');
  
      // remove active class from all tabs and tab contents
      tabs.forEach((tab) => tab.classList.remove('tt_active'));
      tabContents.forEach((content) => content.classList.remove('ct_active'));
  
      // add active class to clicked tab and corresponding tab content
      tab.classList.add('tt_active');
      document.getElementById(tabId).classList.add('ct_active');
    });
  });

}());